//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    label: {
      default: 'Loading...'
    },
    show: {
      default: false
    },
    overlay: {
      default: true
    },
    loaderClass: {
      default: 'loader-wrapper'
    },
    overlayClass: {
      default: 'white-overlay'
    },
    // central event bus
    eventBus: {
      default: null
    },
    eventShow: {
      default: 'show-full-loading'
    },
    eventHide: {
      default: 'hide-full-loading'
    }
  },
  data: function data() {
    return {
      showing: false
    };
  },
  watch: {
    show: function show(val) {
      this.showing = val;
    }
  },
  methods: {
    showMe: function showMe() {
      this.showing = true;
    },
    hideMe: function hideMe() {
      this.showing = false;
    },
    // Register eventBus methods.
    registerBusMethods: function registerBusMethods() {
      this.eventBus.$on(this.eventShow, this.showMe);
      this.eventBus.$on(this.eventHide, this.hideMe);
    }
  },
  mounted: function mounted() {
    // If event bus, register methods.
    if (this.eventBus) this.registerBusMethods();
  }
};